import pt from 'prop-types';

import React, { createContext, useContext, useState } from 'react';
import { DEFAULT_DATA_USER_INFO } from './hooks/useUserState';
import { useToken } from './hooks/useToken';
import { useRefreshToken } from './hooks/useRefreshToken';
import { useLoginWithRedirect } from './hooks/useLoginWithRedirect';

const UserContextValue = createContext(DEFAULT_DATA_USER_INFO);

export const UserContext = ({ children }) => {
  const [state, setState] = useState(DEFAULT_DATA_USER_INFO);
  const { getToken, setToken } = useToken();
  const { refreshToken, refreshTokenAsync } = useRefreshToken({ setToken });
  const loginWithRedirect = useLoginWithRedirect();

  const { currentOrg, hasRoles, isLoading, isOrgOverride, user, error } = state;

  return (
    <UserContextValue.Provider
      value={{
        user,
        currentOrg,
        hasRoles,
        isLoading,
        isOrgOverride,
        error,
        setState,
        refreshToken,
        refreshTokenAsync,
        getToken,
        setToken,
        loginWithRedirect,
      }}
    >
      {children}
    </UserContextValue.Provider>
  );
};

export const useUserContext = () => {
  return useContext(UserContextValue);
};

UserContext.propTypes = {
  children: pt.node.isRequired,
};
